<template>
  <component class="text-danger" :is="tag">{{ label }}</component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
    label: {
      type: String,
      default: "*",
    },
  },
};
</script>